import $ from 'jquery';
// import "readmore-js";

export default class spa {
  constructor() {
    this.bindEvents();
  }

  bindEvents(){
    $('.jsc-btn-click_01').on('click', () => {
      $('.jsc-event-click_01').toggleClass('is-open')
      $('.jsc-btn-click_01').addClass('u-is-hidden')
    });
    $('.jsc-btn-click_02').on('click', () => {
      $('.jsc-event-click_02').toggleClass('is-open')
      $('.jsc-btn-click_02').addClass('u-is-hidden')
    });
  }
}


// WEBPACK FOOTER //
// ./dev/js/spa.js